import supabase from '../supabase/supabase';
import {
  assertSessionWritePayload,
  buildSessionPayload,
  isValidSessionId
} from './sessionPersistence';

const SESSION_TABLE='fishing_sessions_1789506688831';

export const insertFishingSession=async(values)=> {
  const payload=assertSessionWritePayload(
    buildSessionPayload(values,{id: values.id}),
    'insertFishingSession'
  );

  const result=await supabase
    .from(SESSION_TABLE)
    .insert(payload)
    .select('id,guide_id,trip_type_id,date,start_time,capacity,status,notes,calendar_conflict_status,created_at,updated_at')
    .single();

  if (result.error) {
    console.error('[SOSBooking session insert failed]',{
      operation: 'insertFishingSession',
      payload,
      error: result.error
    });
    throw result.error;
  }

  if (!isValidSessionId(result.data?.id)) {
    throw new Error('Supabase returned a fishing session without a valid id after insert.');
  }

  return result.data;
};

export const updateFishingSession=async(values)=> {
  if (!isValidSessionId(values?.id)) {
    throw new Error(
      'Existing fishing session update was blocked because the persisted session id was missing.'
    );
  }

  const payload=assertSessionWritePayload(
    buildSessionPayload(values,{id: values.id}),
    'updateFishingSession'
  );

  const result=await supabase
    .from(SESSION_TABLE)
    .update(payload)
    .eq('id',values.id)
    .eq('guide_id',values.guide_id || 'guide_demo')
    .select('id,guide_id,trip_type_id,date,start_time,capacity,status,notes,calendar_conflict_status,created_at,updated_at')
    .single();

  if (result.error) {
    console.error('[SOSBooking session update failed]',{
      operation: 'updateFishingSession',
      payload,
      error: result.error
    });
    throw result.error;
  }

  if (!isValidSessionId(result.data?.id) || result.data.id!==values.id) {
    throw new Error('Fishing session update returned an unstable or missing session id.');
  }

  return result.data;
};

export const insertFishingSessions=async(sessions,operation)=> {
  const payload=sessions.map((session)=> assertSessionWritePayload(
    buildSessionPayload(session,{id: session.id,createdAt: session.created_at}),
    operation
  ));

  if (!payload.length) return [];

  const result=await supabase
    .from(SESSION_TABLE)
    .insert(payload)
    .select('id,guide_id,trip_type_id,date,start_time,capacity,status,notes,calendar_conflict_status,created_at,updated_at');

  if (result.error) {
    console.error('[SOSBooking bulk session insert failed]',{
      operation,
      payload,
      error: result.error
    });
    throw result.error;
  }

  result.data.forEach((session)=> {
    if (!isValidSessionId(session.id)) {
      throw new Error(`Bulk session operation ${operation} returned a missing session id.`);
    }
  });

  return result.data;
};

export const upsertFishingSessions=async(sessions,operation)=> {
  const payload=sessions.map((session)=> assertSessionWritePayload(
    buildSessionPayload(session,{id: session.id,createdAt: session.created_at}),
    operation
  ));

  if (!payload.length) return [];

  const result=await supabase
    .from(SESSION_TABLE)
    .upsert(payload)
    .select('id,guide_id,trip_type_id,date,start_time,capacity,status,notes,calendar_conflict_status,created_at,updated_at');

  if (result.error) {
    console.error('[SOSBooking bulk session upsert failed]',{
      operation,
      payload,
      error: result.error
    });
    throw result.error;
  }

  result.data.forEach((session)=> {
    if (!isValidSessionId(session.id)) {
      throw new Error(`Bulk session operation ${operation} returned a missing session id.`);
    }
  });

  return result.data;
};